export default "__VITE_ASSET__BLITraxN__"